import React from 'react';
import { Instagram, Facebook, Twitter, Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
const instagramGrid = ['https://images.unsplash.com/photo-1555244162-803834f70033?auto=format&fit=crop&q=80&w=300', 'https://images.unsplash.com/photo-1528605248644-14dd04022da1?auto=format&fit=crop&q=80&w=300', 'https://images.unsplash.com/photo-1547592166-23ac45744acd?auto=format&fit=crop&q=80&w=300', 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?auto=format&fit=crop&q=80&w=300', 'https://images.unsplash.com/photo-1604329760661-e71dc83f8f26?auto=format&fit=crop&q=80&w=300', 'https://images.unsplash.com/photo-1544025162-d76694265947?auto=format&fit=crop&q=80&w=300'];
interface FooterProps {
  onOpenQuote: () => void;
}
export function Footer({
  onOpenQuote
}: FooterProps) {
  return <footer className="bg-brand-black text-white pt-24 pb-12 border-t border-white/10" data-id="element-95">
      <div className="max-w-7xl mx-auto px-6" data-id="element-96">
        <div className="grid lg:grid-cols-4 gap-16 mb-20" data-id="element-97">
          {/* Brand & Social */}
          <div className="col-span-1 lg:col-span-1" data-id="element-98">
            <img src="https://cdn.magicpatterns.com/uploads/otjuHu8XNsL2f4dQ3LfjEG/ChatGPT_Image_Apr_22,_2026,_03_42_32_PM.png" alt="Logo" className="h-24 w-auto mb-8 object-contain" data-id="element-99" />
            <p className="text-gray-400 mb-8 leading-relaxed" data-id="element-100">
              Exceptional cuisine for every occasion. African woman-owned and
              operated, serving the DMV area with pride.
            </p>
            <div className="flex gap-4" data-id="element-101">
              <a href="#" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:bg-brand-gold hover:border-brand-gold transition-all" data-id="element-102">
                <Instagram size={18} data-id="element-103" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:bg-brand-gold hover:border-brand-gold transition-all" data-id="element-104">
                <Facebook size={18} data-id="element-105" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:bg-brand-gold hover:border-brand-gold transition-all" data-id="element-106">
                <Twitter size={18} data-id="element-107" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-108">
            <h4 className="text-brand-gold uppercase tracking-widest text-sm font-bold mb-8" data-id="element-109">
              Navigation
            </h4>
            <ul className="space-y-4 text-gray-400" data-id="element-110">
              <li data-id="element-111">
                <Link to="/" className="hover:text-white transition-colors" data-id="element-112">
                  Home
                </Link>
              </li>
              <li data-id="element-113">
                <Link to="/menu" className="hover:text-white transition-colors" data-id="element-114">
                  Menu
                </Link>
              </li>
              <li data-id="element-115">
                <Link to="/events" className="hover:text-white transition-colors" data-id="element-116">
                  Our Events
                </Link>
              </li>
              <li data-id="element-117">
                <Link to="/services" className="hover:text-white transition-colors" data-id="element-118">
                  Event Services
                </Link>
              </li>
              <li data-id="element-119">
                <Link to="/services/meal-prep" className="hover:text-white transition-colors" data-id="element-120">
                  Meal Prep
                </Link>
              </li>
              <li data-id="element-121">
                <Link to="/story" className="hover:text-white transition-colors" data-id="element-122">
                  Our Story
                </Link>
              </li>
              <li data-id="element-123">
                <button onClick={onOpenQuote} className="hover:text-white transition-colors text-left" data-id="element-124">
                  Request a Quote
                </button>
              </li>
            </ul>
          </div>

          {/* Contact & SEO */}
          <div data-id="element-125">
            <h4 className="text-brand-gold uppercase tracking-widest text-sm font-bold mb-8" data-id="element-126">
              Contact Us
            </h4>
            <ul className="space-y-6 text-gray-400" data-id="element-127">
              <li className="flex gap-4" data-id="element-128">
                <MapPin className="text-brand-gold shrink-0" size={20} data-id="element-129" />
                <span data-id="element-130">Serving DC, Maryland, and Northern Virginia (DMV)</span>
              </li>
              <li className="flex gap-4" data-id="element-131">
                <Phone className="text-brand-gold shrink-0" size={20} data-id="element-132" />
                <span data-id="element-133">(202) 555-0123</span>
              </li>
              <li className="flex gap-4" data-id="element-134">
                <Mail className="text-brand-gold shrink-0" size={20} data-id="element-135" />
                <span data-id="element-136">hello@versatilityeats.com</span>
              </li>
            </ul>
          </div>

          {/* Instagram Grid */}
          <div data-id="element-137">
            <h4 className="text-brand-gold uppercase tracking-widest text-sm font-bold mb-8" data-id="element-138">
              Follow Our Journey
            </h4>
            <div className="grid grid-cols-3 gap-2" data-id="element-139">
              {instagramGrid.map((img, i) => <div key={i} className="aspect-square overflow-hidden rounded-sm" data-id="element-140">
                  <img src={img} alt="Instagram" className="w-full h-full object-cover hover:scale-110 transition-transform duration-500" data-id="element-141" />
                </div>)}
            </div>
          </div>
        </div>

        <div className="pt-12 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6 text-sm text-gray-500" data-id="element-142">
          <p data-id="element-143">© 2026 Versatile LLC Cater 2 U. All rights reserved.</p>
          <div className="flex gap-8" data-id="element-144">
            <Link to="/privacy-policy" className="hover:text-white transition-colors" data-id="element-145">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="hover:text-white transition-colors" data-id="element-146">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}